import { gql } from "@apollo/client";

export const SearchAssetBoundingBox = gql`
    query SearchAssetBoundingBox($filter: SearchAssetFilter) {
        searchAssetBoundingBox(filter: $filter) {
            northeast {
                lat
                lng
            }
            southwest {
                lat
                lng
            }
        }
    }
`;
